import theme from 'src/theme';

export const messageSx = {
    userRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2.5,
    },
    assistantRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        mb: 2.5,
        gap: 1.5,
        alignItems: 'flex-start',
    },
    avatar: {
        width: 34,
        height: 34,
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #007FDC 0%, #28419D 50%, #007FDC 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        mt: 0.25,
        color: theme.palette.common.white,
        fontSize: 18,
        boxShadow: '0 2px 6px rgba(0, 127, 220, 0.25)',
    },
    userBubble: {
        maxWidth: '75%',
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        color: theme.palette.common.white,
        borderRadius: '18px 18px 4px 18px',
        px: 2.5,
        py: 1.5,
        wordBreak: 'break-word',
        fontSize: '0.875rem',
        lineHeight: 1.7,
        boxShadow: '0 2px 6px rgba(0, 127, 220, 0.18)',
    },
    assistantBubble: {
        width: '85%',
        flexShrink: 0,
        bgcolor: theme.palette.common.white,
        color: theme.palette.text.primary,
        borderRadius: '18px 18px 18px 4px',
        px: 2.5,
        py: 1.75,
        wordBreak: 'break-word',
        fontSize: '0.875rem',
        lineHeight: 1.7,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.03)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        '& p': {m: 0},
        '& p + p': {mt: 1.5},
        '& pre': {
            bgcolor: '#F4F6F9',
            borderRadius: '10px',
            p: 2,
            overflow: 'auto',
            fontSize: '0.8rem',
            border: '1px solid rgba(0, 0, 0, 0.05)',
            fontFamily: '"SF Mono", "Fira Code", Menlo, monospace',
        },
        '& code': {
            fontSize: '0.8rem',
            bgcolor: '#EEF1F5',
            px: 0.75,
            py: 0.25,
            borderRadius: '5px',
            fontFamily: '"SF Mono", "Fira Code", Menlo, monospace',
        },
        '& pre code': {
            bgcolor: 'transparent',
            px: 0,
            py: 0,
        },
        '& table': {
            borderCollapse: 'collapse',
            width: '100%',
            my: 2,
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid rgba(0, 0, 0, 0.06)',
            '& tr:hover': {
                bgcolor: 'rgba(0, 127, 220, 0.04)',
            },
        },
        '& th, & td': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            px: 1.5,
            py: 0.75,
            fontSize: '0.82rem',
            textAlign: 'left',
        },
        '& th': {
            bgcolor: '#F4F6F9',
            fontWeight: 600,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            color: theme.palette.neutral[600],
        },
        '& tr:last-child td': {borderBottom: 'none'},
        '& ul, & ol': {pl: 2.5, my: 1},
        '& li': {mb: 0.5},
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'none',
            fontWeight: 500,
            '&:hover': {textDecoration: 'underline'},
        },
        '& strong': {fontWeight: 600},
        '& blockquote': {
            borderLeft: `3px solid ${theme.palette.primary.light}`,
            pl: 2,
            ml: 0,
            my: 1.5,
            color: theme.palette.neutral[600],
        },
    },
    typingDots: {
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        gap: 0.4,
        ml: 0.5,
        '& span': {
            width: 5,
            height: 5,
            borderRadius: '50%',
            bgcolor: theme.palette.primary.main,
            animation: 'dotPulse 1.4s infinite ease-in-out',
        },
        '& span:nth-of-type(1)': {animationDelay: '0s'},
        '& span:nth-of-type(2)': {animationDelay: '0.16s'},
        '& span:nth-of-type(3)': {animationDelay: '0.32s'},
        '@keyframes dotPulse': {
            '0%, 80%, 100%': {opacity: 0.3, transform: 'scale(0.8)'},
            '40%': {opacity: 1, transform: 'scale(1)'},
        },
    },
};